export default __webpack_public_path__ + "pdfjs-dist-ie11-ledge/annotation_layer_builder-9b7a5768582a49cb21c0488162a8fff0.css";